












import {Vue, Component, Prop} from "vue-property-decorator";

@Component({
    name: 'TableArrows',
})
export default class TableArrows extends Vue {

    @Prop({default: false}) isReversed: boolean;
    @Prop() filterName: string;
    @Prop() fieldName: string;

}
